import {TOGGLE_FULLSCREEN, ENTER_FULLSCREEN, LEAVE_FULLSCREEN, OPEN_ALL_STEPS, CLOSE_ALL_STEPS} from '../actions/ui.action.js';
import {CLOSE_ALL_SOLUTIONS, OPEN_ALL_SOLUTIONS} from '../actions/problem.action.js';
import {default_state} from './index.js';
import localStorage from '../helpers/localStorage.js';

export const STORAGE_OPENSTATUS_KEY = 'TBS_openStatus';
export const OPEN_STATUS_OPEN = 'open';
export const OPEN_STATUS_CLOSED = 'closed';

export function getInitialState(state=default_state.ui) {
    let saved_open_value = localStorage.getItem(STORAGE_OPENSTATUS_KEY) || false;
    return {
        ...state,
        all_steps_open_status : saved_open_value || state.all_steps_open_status
    };
}

export function ui(state=default_state.ui, action={}){
    switch (action.type){
        case TOGGLE_FULLSCREEN:
            return {
                ...state,
                is_fullscreen: !state.is_fullscreen
            };

        case ENTER_FULLSCREEN:
            return {
                ...state,
                is_fullscreen: true
            };

        case LEAVE_FULLSCREEN:
            return {
                ...state,
                is_fullscreen: false
            }

        case CLOSE_ALL_SOLUTIONS:
            localStorage.setItem(STORAGE_OPENSTATUS_KEY, OPEN_STATUS_CLOSED)
            return {
                ...state,
                all_steps_open_status: OPEN_STATUS_CLOSED
            }

        case OPEN_ALL_SOLUTIONS:
            localStorage.setItem(STORAGE_OPENSTATUS_KEY, OPEN_STATUS_OPEN)
            return {
                ...state,
                all_steps_open_status: OPEN_STATUS_OPEN
            }
    }

    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/ui.reducer.js